import styled from 'styled-components';

export const LoadingInvoiceContainer = styled.div`
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const StepText = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: ${(props) => props.theme.color.text.secondary};
  margin: 0;
`;

export const StepList = styled.ul`
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StepItem = styled.li<{ $done: boolean; $active: boolean }>`
  font-size: 14px;
  color: ${(props) =>
    props.$done
      ? props.theme.color.ui.orange
      : props.$active
      ? props.theme.color.text.primary
      : props.theme.color.text.disabled};
  font-weight: ${(props) => (props.$active ? 600 : 400)};
`;
